import { PropTypeMediaEntry } from "fleet/prop-types";
import React from "react";
import Alert from "react-bootstrap/Alert";

function AppUnavailable(props) {
  const { mediaEntry } = props;
  const { displayName, friendlyType, installed, type, available } = mediaEntry;
  if (type !== "application") {
    return null;
  }

  if (installed && available) {
    return null;
  }

  // When we denormalize a strategy, a missing application in strategy is not
  // available in global applications store. Therefore it won't have an id in
  // mediaEntry.
  const title = available
    ? `${friendlyType} ${displayName} is not installed for your account.`
    : `This ${friendlyType} is no longer available in your account.`;

  return (
    <Alert className="alert-archived-content">
      <i className="fa fa-warning" />
      {title}
      <p>
        <small>Please update your strategy.</small>
      </p>
    </Alert>
  );
}

AppUnavailable.propTypes = {
  mediaEntry: PropTypeMediaEntry,
};

export { AppUnavailable };
